"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResourceById = getResourceById;
exports.getResourceMetadata = getResourceMetadata;
exports.getResourceStatus = getResourceStatus;
exports.getResources = getResources;

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _warning = _interopRequireDefault(require("@flowio/warning"));

var _constants = require("../constants");

var _converters = require("../utilities/converters");

var _introspection = require("../utilities/introspection");

var _language = require("../utilities/language");

function pickResourcesById(resources) {
  var resourceIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return resourceIds.reduce(function (previousValue, resourceId) {
    if (!(0, _language.hasOwnProperty)(resources, resourceId)) {
      return previousValue;
    }

    return [].concat((0, _toConsumableArray2.default)(previousValue), [resources[resourceId]]);
  }, []);
}

function getResourceById(state, resourceId) {
  return state.resources[resourceId];
}

function getResources(state, filter) {
  if ((0, _language.isNil)(state)) {
    return [];
  }

  var idAttribute = state.idAttribute,
      lists = state.lists,
      metadata = state.metadata,
      resources = state.resources;

  if ((0, _language.isString)(filter)) {
    return pickResourcesById(resources, lists[filter]);
  }

  if ((0, _language.isArray)(filter)) {
    return pickResourcesById(resources, filter);
  }

  if ((0, _language.isFunction)(filter)) {
    return (0, _values.default)(resources).filter(function (resource) {
      var resourceId = resource[idAttribute];
      var resourceMetadata = metadata[resourceId];
      return filter(resource, resourceMetadata, state);
    });
  }

  return (0, _values.default)(resources);
}

function getResourceMetadata(state, resourceId) {
  return state.metadata[resourceId] || {};
}

function getResourceStatus(state, resourceId, operationType) {
  (0, _warning.default)((0, _introspection.isValidOperationType)(operationType), 'The provided operation type argument value is invalid. An operation type ' + 'must be one of: `"create"`, `"read"`, `"update", or `"delete"`.');
  var metadata = getResourceMetadata(state, resourceId);
  var _metadata$createStatu = metadata.createStatus,
      createStatus = _metadata$createStatu === void 0 ? _constants.readyState.IDLE : _metadata$createStatu,
      _metadata$readStatus = metadata.readStatus,
      readStatus = _metadata$readStatus === void 0 ? _constants.readyState.IDLE : _metadata$readStatus,
      _metadata$updateStatu = metadata.updateStatus,
      updateStatus = _metadata$updateStatu === void 0 ? _constants.readyState.IDLE : _metadata$updateStatu,
      _metadata$deleteStatu = metadata.deleteStatus,
      deleteStatus = _metadata$deleteStatu === void 0 ? _constants.readyState.IDLE : _metadata$deleteStatu;

  switch (operationType) {
    case _constants.operationTypes.CREATE:
      return (0, _converters.statusObjectFromRequestStatus)(createStatus);

    case _constants.operationTypes.READ:
      return (0, _converters.statusObjectFromRequestStatus)(readStatus);

    case _constants.operationTypes.UPDATE:
      return (0, _converters.statusObjectFromRequestStatus)(updateStatus);

    case _constants.operationTypes.DELETE:
      return (0, _converters.statusObjectFromRequestStatus)(deleteStatus);

    default:
      return undefined;
  }
}